module.exports = __webpack_public_path__ + "files/net-framework4-data-access.92345cb9.pdf";